@if (edit && isCompletedChange()) {
    <button mat-button class="mat-icon-button" (click)="completeChangeClicked()">
        <mat-icon class="mat-primary">check_box</mat-icon>
    </button>
}
@if (edit && isNotStartedChange()) {
    <button mat-button class="mat-icon-button" (click)="notStartedChangeClicked()">
        <mat-icon>check_box_outline_blank</mat-icon>
    </button>
}
@if (!edit && isCompletedChange()) {
    <mat-icon class="mat-primary">check_box</mat-icon>
}
@if (!edit && isNotStartedChange()) {
    <mat-icon>check_box_outline_blank</mat-icon>
}
